// Focus Input and select in view on tabbing
document.addEventListener('keyup', (event) => {
  if (!(event.shiftKey) && event.keyCode === 9) {
      if(event.target.type === 'checkbox'){
        window.scrollBy(0,150)
      }
  }
})
